import { Alert, Link } from '@mm/components';
import { landmineNames } from '@mm/constants/landmine-names';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import {
  defaultProPlanSelector,
  defaultProUnicornPlanSelector,
} from '@mm/state/selectors/subscriptionSelectors';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLandmineOpensHelpers } from '../../../../../common/modals/UniversalUpgradeModal/useLandmineOpensHelpers';

type Props = {
  className?: string;
  trialEnded: boolean;
  forSponsored: boolean;
};

export const FacebookAdsAlert = ({
  className,
  trialEnded,
  forSponsored,
}: Props) => {
  const facebookPage = useSelector(activeFacebookPageSelector);
  const modalActions = useModalActions();
  const defaultProPlan = useSelector(defaultProPlanSelector);
  const unicornPlan = useSelector(defaultProUnicornPlanSelector);
  const { november2021Pricing } = useSelector(combinedFeatureFlagsSelector);

  const featureName = forSponsored
    ? 'Sponsored Messages'
    : 'Click-to-Messenger ads';
  const planToUse = trialEnded ? defaultProPlan : unicornPlan;
  const upgradeText =
    trialEnded && !november2021Pricing
      ? 'Upgrade to Operator'
      : 'Upgrade to Startup';
  const alertText = trialEnded
    ? `Your Free Trial has expired. To continue using ${featureName}, `
    : `You no longer have access to this Startup feature. To continue using ${featureName}, `;

  const { landmineOpenId, landmineOpensCRUDActions } = useLandmineOpensHelpers(
    landmineNames.ADS_ALERT_UPGRADE_BUTTON,
    trialEnded ? 'pro' : 'unicorn',
  );

  const onAlertClick = () => {
    if (landmineOpenId) {
      landmineOpensCRUDActions.update(landmineOpenId, true);

      if (planToUse) {
        modalActions.openBillingModal({
          facebookPage,
          plan: planToUse,
          landmineOpenId,
          stayOnPage: false,
        });
      }
    }
  };

  return (
    <Alert
      className={classNames(className)}
      type="warning"
      onClick={onAlertClick}
    >
      <div>
        <span>{alertText}</span>

        <Link
          href=""
          className="ad-detail__alert-action"
          onClick={e => e.preventDefault()}
        >
          {upgradeText}
        </Link>
      </div>
    </Alert>
  );
};
